import { BehaviorSubject, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { sortBy } from 'lodash';
var CrudService = /** @class */ (function () {
    function CrudService(_http, cache) {
        if (cache === void 0) { cache = true; }
        this._http = _http;
        this.cache = cache;
        this.values$ = new BehaviorSubject(null);
    }
    Object.defineProperty(CrudService.prototype, "orderByProperty", {
        /**
         * This function is used to order the items again after editing or adding an item
         */
        get: function () {
            return 'id';
        },
        enumerable: true,
        configurable: true
    });
    CrudService.prototype.list = function () {
        var _this = this;
        if (this.values$.value && this.cache) {
            return this.values$.asObservable();
        }
        return this._http.get("" + this.url).pipe(catchError(function (error) { return of([]); }), switchMap(function (values) {
            _this.values$.next(values);
            return _this.values$;
        }));
    };
    CrudService.prototype.get = function (valueId) {
        return this._http.get(this.url + "/" + valueId);
    };
    CrudService.prototype.add = function (value) {
        var _this = this;
        return this.addRequest(value).pipe(tap(function (_value) { return _this.addValue(_value); }));
    };
    CrudService.prototype.edit = function (value) {
        var _this = this;
        return this.editRequest(value).pipe(tap(function (_value) { return _this.updateValue(value, _value); }));
    };
    CrudService.prototype.delete = function (valueId) {
        var _this = this;
        return this.deleteRequest(valueId).pipe(tap(function () { return _this.removeValue(valueId); }));
    };
    CrudService.prototype.addValue = function (_value) {
        if (this.values$.value) {
            var valueIndex = this.findAddedValueIndex(_value);
            var values = void 0;
            values = this.values$.value.slice();
            if (valueIndex > -1) {
                values.splice(valueIndex, 0, _value);
            }
            else {
                values.push(_value);
            }
            this.values$.next(values);
        }
        return _value;
    };
    CrudService.prototype.addRequest = function (value) {
        return this._http.post("" + this.url, value);
    };
    CrudService.prototype.editRequest = function (value) {
        return this._http.patch(this.url + "/" + value.id, value);
    };
    CrudService.prototype.deleteRequest = function (valueId) {
        return this._http.delete(this.url + "/" + valueId);
    };
    CrudService.prototype.removeValue = function (valueId) {
        if (this.values$.value) {
            var values = this.values$.value.filter(function (value) { return value.id !== valueId; });
            this.values$.next(values);
        }
    };
    CrudService.prototype.updateValue = function (value, _value) {
        if (this.values$.value) {
            var values = this.values$.value.slice();
            var valueIndex = values.findIndex(function (item) { return item.id === value.id; });
            values[valueIndex] = _value;
            this.values$.next(this.sortValues(values));
        }
        return _value;
    };
    CrudService.prototype.sortValues = function (values) {
        var property = this.orderByProperty;
        return sortBy(values, [property]);
    };
    CrudService.prototype.findAddedValueIndex = function (_value) {
        var property = this.orderByProperty;
        return this.values$.value.findIndex(function (value) {
            if (typeof value[property] === 'string') {
                return value[property].toLowerCase() > _value[property].toLowerCase();
            }
            return value[property] > _value[property];
        });
    };
    return CrudService;
}());
export { CrudService };
